import * as React from "react"
import {DateFormat} from "../../helpers/DateFormat";
import DataTable from "../../components/DataTable/DataTable";
import {columnOffsets} from "./Config";
import {useEffect, useState} from "react";
import {StatusChip} from "./StatusChip";

const {
    ID, SERIAL, TYPE, NAME, CUSTOMER, SITE, LAST_REPORTED,
    STATUS, TEST_STATUS, HW_VERSION, SW_VERSION
} = columnOffsets;

function describeTestStatus(device){
    const status = device[TEST_STATUS];
    switch (status){
        case 'untested':
            return 'No'
        case 'tested':
            return 'Yes'
        default:
            return 'New'
    }
}

const MISSING_CUSTOMER = {
    name: 'None',
    sites: []
}, MISSING_SITE = {
    name: 'None'
}

export default function ({customers, devices, onEdit, onDelete}){
    const [data, setData] = useState([])
    const [lookup, setLookup] = useState({})

    useEffect(() => {
        if (!(devices && customers)){
            return
        }
        const map = {}
        setData(devices.map(device => {
            const customer = customers.map[device[CUSTOMER]] || MISSING_CUSTOMER;
            const site = customer.sites.find(site => site.id === device[SITE]) || MISSING_SITE
            const code = device[SERIAL]
            map[code] = device
            return [
                device[SERIAL], device[TYPE], device[NAME], customer.name,
                site.name, device[HW_VERSION], device[SW_VERSION],
                describeTestStatus(device),
                device[LAST_REPORTED], device[STATUS]
            ]
        }))
        setLookup(map)
    }, [devices, customers]);

    return <DataTable
        data={data}
        columns={[{
            name: "Device ID",
            options: {
                customBodyRender: (deviceCode) => {
                    const device = lookup[deviceCode]
                    const deviceId = device && device[ID]
                    return deviceId
                        ? <a href={`#/app/edit-device/${deviceId}`} target="device_code" onClick={e => e.stopPropagation()}>{deviceCode}</a>
                        : deviceCode
                }
            }
        }, "Type", "Name", "Customer", "Site", "Hw ver", "Sw ver", {
            name: "Tested",
            options: {
                customBodyRender: (tested) => {
                    return tested === 'No' ? <span style={{color: '#c00'}}>No</span> : tested
                }
            }
        }, {
            name: "Last Report",
            options: {
                customBodyRender: (reported) => reported ? (new DateFormat(reported)).datetime() : 'never'
            }
        }, {
            name: 'Status',
            options: {
                customBodyRender: (status) => {
                    return <StatusChip status={status}/>
                }
            }
        }]}
        onEdit={row => onEdit(lookup[row[0]])}
        onDelete={row => onDelete(lookup[row[0]])}
        sortOrder={{name: 'Status', direction: 'asc'}}
    />
}
